/**
 * 作品的点赞、收藏、改编
 */

import React, {useState, useEffect} from 'react';
import { showToast } from '@turingshequ/react-toast/src'
import service, {API} from 'fetch/service';
import { like } from 'fetch'
import {num2likestr} from 'util/index';
import { YDLog } from 'components/YDLog'
import { REPORT_TYPE } from '../ToReport'

import {iconLiked, iconSave, iconEdit, iconTriangle} from 'assets';

import s from './index.module.scss';

enum LIKE_ENUM {
  like = 1,
  cancelLike = 2,
}

interface Props {
  workId: string
  likedNum?: number,
  collectNum?: number,
  haveLiked?: boolean,
  haveCollected?: boolean,
  haveReported?: number
  onForkClick?: () => void,
  unLogin: () => boolean,
  onToReportClick: (data?: any) => void,
}


function toastError() {
  showToast({
    type: 'error',
    message: '操作过于频繁，请稍后再试试～'
  })
}
const HandleLine: React.FC<Props> = ({
  workId,
  haveLiked,
  likedNum = 0,
  collectNum = 0,
  haveCollected,
  onForkClick,
  unLogin,
  onToReportClick,
  haveReported
}) => {

  const [liked, setLiked] = useState({
    num: likedNum || 0,
    flag: haveLiked
  });
  const [collect, setCollect] = useState({
    num: collectNum || 0,
    flag: haveCollected
  });

  useEffect(() => {
    setLiked({
      num: likedNum || 0,
      flag: haveLiked
    })
    setCollect({
      num: collectNum || 0,
      flag: haveCollected
    })
  }, [likedNum, haveLiked, collectNum, haveCollected])

  const onCollectClick = () => {
      if(unLogin()) {
        return;
      }
      const api = collect.flag ? API.works.unEnshrine : API.works.enshrine;
      const num = collect.flag ? -1 : 1;
      service.post(api, {}, {params: {worksId: workId}})
      .then(() => {
        setCollect(s => {
          return {
            num: Math.max(((collect.num || 0) + num), 0),
            flag: !s.flag
          }
        })
      }, toastError)
  }

  const onLikeClick = () => {
      if(unLogin()) {
        return;
      }
      const params = {
        id: workId,
        type: liked.flag ? LIKE_ENUM.cancelLike : LIKE_ENUM.like
      }
      const num = liked.flag ? -1 : 1;
      like(params).then(() => {
        setLiked(s => {
          return {
            num: Math.max(((liked.num || 0) + num), 0),
            flag: !s.flag
          }
        })
      }, toastError)
  }

  const handleToReportClick = () => {
    if(unLogin()) {
      return;
    }
    onToReportClick({
      type: REPORT_TYPE.work,
      id: workId
    });
  }

  return (<div className={s.wrap}>
    <YDLog click={{ name: 'click', data: { button_name: '点赞', like_type: '点赞作品' } }}>
    <div className={`${s.item} ${liked.flag && s.origin}`} onClick={onLikeClick} >
      <img src={iconLiked} alt="点赞" />点赞({num2likestr(liked.num)})
    </div>
    </YDLog>
    <YDLog click={{ name: 'click', data: { button_name: '收藏' } }}>
    <div className={`${s.item} ${collect.flag && s.red}`} onClick={onCollectClick}>
      <img src={iconSave} alt="收藏" />收藏({num2likestr(collect.num)})
    </div>
    </YDLog>
    <YDLog click={{ name: 'click', data: { button_name: '改编' } }}>
    <div className={s.item} onClick={onForkClick}>
      <img className={s.img} src={iconEdit} alt="改编" />改编
    </div>
    </YDLog>
    <YDLog click={{ name: 'click', data: { button_name: '举报', jubao_type: '举报作品' } }}>
      <div
        className={`${s.item} ${s.toReport} ${haveReported === 1 && s.haveReported}`}
        onClick={handleToReportClick}
      >
        <img className={s.img} src={iconTriangle} alt="举报" />
        举报
      </div>
    </YDLog>
  </div>)
}
export default React.memo(HandleLine);
